import TwoFactorAuthVerified from './Presentational/TwoFactorAuthVerified';
import classes from './TwoFactorAuth.scss';
import {getLocalizedStringstwo} from'./twoFactorAuthenticationStrings';
import EmailStepOne from './Presentational/Email/EmailStepOne';
import EmailStepTwo from './Presentational/Email/EmailStepTwo';
import PhoneStepOne from './Presentational/Phone/PhoneStepOne';
import PhoneStepTwo from './Presentational/Phone/PhoneStepTwo';

class TwoFactorAuthContainer extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStringstwo('TwoFactorAuthentication'); 
      this.state = {
      currentStep: 'StepOne',
      phoneType: { validStyle: '', outlineStyle: '', value:this.strings.mobile , labels:[this.strings.mobile,this.strings.landline]},
      disableVerifyBtn: true, verifyPin: '', isCall: false, isTwoFaCompleted: false,disableSendCodeBtn:false,
      resendSuccess: true, resendExceedMsg: '',invalidCodeError:false,sendCodeResponse:''

    };
   
    this.PIN_LENGTH = this.props.twoFactorAuthValues.type==='email' || this.props.twoFactorAuthValues.type === 'text' ? 6 : 5;
    this.resendCounter = 0;
    this.MAX_RESEND_LIMIT = 10;
    this.RESEND_DISABLE_TIME = 30 * 60 * 1000;
    this.ISCALL = this.props.twoFactorAuthValues.type === 'voice';
    this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    this.maskedValue = this.props.twoFactorAuthValues.type==='email' ? this.formatEmailIdWithStar(this.props.twoFactorAuthValues.value) : this.formatPhoneNumWithStar(this.props.twoFactorAuthValues.value);
}


sendCodeHandler= () => { 
  this.setState({disableSendCodeBtn:true});
  window.aUtils.sendAAEvent("button","sendCode");
  const twoFactorAuthValues = this.props.twoFactorAuthValues;
  twoFactorAuthValues.factors = this.props.factors ? true : false;
  app.centralizedService.twoFactorAuthSendCode(twoFactorAuthValues).then(
    (response) => {
        if (response.sendPinstatus === 'Success') {     
          this.setState({currentStep: 'StepTwo',sendCodeResponse:response,disableSendCodeBtn:false});   
        }
    }, (error) => {   
      this.setState({currentStep: 'StepOne',disableSendCodeBtn:false});
    },
  );
}

 
  phoneTypeHandler = (event) => {
    const updatedState = { ...this.state };
    updatedState.phoneType.value = event.currentTarget.value;
    this.setState(updatedState);
  }
  onChangeHandler = (pin) => {
    const updatedState = { ...this.state };
    updatedState.verifyPin = pin,updatedState.invalidCodeError = false;
    this.setState(updatedState,
      () => { this.enableVerifyBtn(); });
  }
  formatPhoneNumWithStar(phoneNumber){
        var phoneNum = phoneNumber.replace(/-/g, "");
        return phoneNum[0]==='*' ? phoneNum.slice(0,3)+'-'+phoneNum.slice(3,6)+'-'+phoneNum.slice(6) : '***-***-'+phoneNum.slice(6);
  }

  formatEmailIdWithStar(emailId){
        return  emailId.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
  }
  enableVerifyBtn = () => {
    const updatedState = { ...this.state };
    if (this.PIN_LENGTH === this.state.verifyPin.length) {
      updatedState.disableVerifyBtn = false;
      this.setState(updatedState);
    }
    else {
      updatedState.disableVerifyBtn = true;
      this.setState(updatedState);
    }
  }
  verifyCodeHandler = () => {    
        this.setState({disableVerifyBtn:true});
        window.aUtils.sendAAEvent("button","verify");
        const twoFactorAuthValues = this.props.twoFactorAuthValues;
        twoFactorAuthValues.factors = this.props.factors ? true : false;
          app.centralizedService.verifyPin(twoFactorAuthValues,this.state.verifyPin,this.state.phoneType.value,this.state.sendCodeResponse).then(
            (response) => {              
                if ((response.factorstatus === 'Success') && (response.saPstatus === 'Success') ) {             
                  this.setState({ currentStep: 'StepThree', isTwoFaCompleted: true,invalidCodeError:false}, ()=>this.props.onTwoFACompleted(this.state.isTwoFaCompleted));
                }
                else{
                  this.setState({invalidCodeError:true});
                }            
            }, (error) => {
                 this.setState({ currentStep: 'StepTwo'});                     
              }
          );          
       } 
  resendCodeHandle = () => {
    if (this.resendCounter < this.MAX_RESEND_LIMIT) {
      const twoFactorAuthValues = this.props.twoFactorAuthValues;
      twoFactorAuthValues.factors = this.props.factors ? true : false;
      app.centralizedService.twoFactorAuthSendCode(twoFactorAuthValues,this.state.sendCodeResponse).then(
        response => {
            if (response.sendPinstatus === 'Success') {
                this.setState({ resendSuccess: true ,sendCodeResponse:response,invalidCodeError: false});
                
            }
            else {
                this.setState({resendSuccess:false,invalidCodeError: false });
            }
        },
        error => {
          this.setState({ resendSuccess:false,invalidCodeError: false});
      });
      this.resendCounter++;
    }
    else {
      this.setState({ resendExceedMsg: this.strings.limitExceedErrorMsg,invalidCodeError: false,resendSuccess:true});
      setTimeout(() => this.setState({ resendExceedMsg: "" }), this.RESEND_DISABLE_TIME);      
      this.resendCounter=0;    
    }

  }
  
  getEmailView = () => {
    switch (this.state.currentStep) {
      case 'StepTwo': 
        return <EmailStepTwo  onChangeHandler={this.onChangeHandler} resendExceedMsg={this.state.resendExceedMsg} maskedValue={this.maskedValue} 
                              resendCodeHandle={this.resendCodeHandle} resendSuccess={this.state.resendSuccess} invalidCodeError={this.state.invalidCodeError}
                              disableVerifyBtn={this.state.disableVerifyBtn} verifyCodeHandler={this.verifyCodeHandler} />;
      case 'StepThree':
        return <TwoFactorAuthVerified handleCloseClick={()=>this.props.closePopup(this.state.isTwoFaCompleted)} isEmail />;
      /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
      default:
        return  <EmailStepOne sendCodeHandler={this.sendCodeHandler}  maskedValue={this.maskedValue} disableSendCodeBtn={this.state.disableSendCodeBtn} />;
    }
  };

  getPhoneView = () => {
   
    switch (this.state.currentStep) {
      case 'StepTwo':
        return <PhoneStepTwo isCall={this.ISCALL} onChangeHandler={this.onChangeHandler} resendExceedMsg={this.state.resendExceedMsg} resendCodeHandle={this.resendCodeHandle} invalidCodeError={this.state.invalidCodeError}
                             phoneType={this.state.phoneType} phoneTypeHandler={this.phoneTypeHandler} resendSuccess={this.state.resendSuccess} pinLength={this.PIN_LENGTH} maskedValue={this.maskedValue}
                            disableVerifyBtn={this.state.disableVerifyBtn} verifyCodeHandler={this.verifyCodeHandler} stepTwo={this.props.twoFactorAuthValues.type} />;
      case 'StepThree':
        return <TwoFactorAuthVerified handleCloseClick={()=>this.props.closePopup(this.state.isTwoFaCompleted)} />;
      /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
      default:
        return   <PhoneStepOne sendCodeHandler={this.sendCodeHandler} maskedValue={this.maskedValue} isCall={this.ISCALL} disableSendCodeBtn={this.state.disableSendCodeBtn} />;
    }
  };
  render() {
    const view = this.props.twoFactorAuthValues.type==='email' ? this.getEmailView():this.getPhoneView();
    return (
      <div>
            <div className={( this.props.twoFactorAuthValues.type==='voice' && this.state.currentStep === 'StepTwo' ) ? [classes.sceDialogBox, classes.marginBottom].join(" ") : classes.sceDialogBox}> 
                <div className={classes.backButton} >
                     <a href="javascript:void(0)" className={classes.backTxt} onClick={()=>this.props.closePopup(this.state.isTwoFaCompleted)}><i className='fas fa-chevron-left' />&nbsp;{this.strings.back}</a>
                 </div>          
                     {view}           
             </div>    
      </div>
    );
  }


}

export default TwoFactorAuthContainer;





